import { createContext, useState } from 'react'
import { Dispatch, FC, JSX, ReactElement, SetStateAction } from 'react'

export interface TitleValues {
  title: string | null | ReactElement
  subTitle?: string | null | ReactElement
  extra?: string | null | ReactElement
}
const initialValues: TitleValues = {
  title: '',
  subTitle: '',
  extra: null
}
const context = {
  values: initialValues,
  setValues: () => undefined
}

interface TitleContextType {
  values: TitleValues
  setValues: Dispatch<SetStateAction<TitleValues>>
}

const TitleContext = createContext<TitleContextType>(context)

interface TitleContextProps {
  children: JSX.Element
}

export const TitleContextProvider: FC<TitleContextProps> = ({ children }) => {
  const [values, setValues] = useState<TitleValues>(initialValues)

  return <TitleContext.Provider value={{ values, setValues }}>{children}</TitleContext.Provider>
}

export default TitleContext
